import styled from 'styled-components';
import base from '@sizeid/commons/utils/base';
import { media } from '@sizeid/commons/utils/styles';

export default styled.div`
  padding-top: ${base(1.5)};

  ${media.moreThan('smPlus')`
    padding-bottom: ${base(5)};
  `};
`;
